import React, { useState } from "react";
import DataTable from "react-data-table-component";

interface viewdatas {
  typeId: number;
  typeName: string;
  isActive: boolean;
}

interface ViewPropertyTypeCardProps {
  viewData: viewdatas[];
  onEdit: (viewdata: viewdatas) => void;
  onAddClick: () => void;
  showAddButton: boolean;
}

const ViewPropertyTypeCard: React.FC<ViewPropertyTypeCardProps> = ({
  viewData,
  onEdit,
  onAddClick,
  showAddButton,
}) => {
  const [toggleCleared, setToggleCleared] = useState(false);

  // Handle row selection
  const handleRowSelected = (state: any) => {
    console.log("Selected rows:", state.selectedRows);
  };

  // Define columns for DataTable
  const columns = [
    {
      name: "Property Type Name",
      selector: (row: viewdatas) => row.typeName,
      sortable: true,
      cell: (row: viewdatas) => (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              backgroundColor: "rgb(167 133 144)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "10px",
              fontWeight: "bold",
            }}
          >
            {row.typeName.charAt(0).toUpperCase()}
          </div>
          <span style={{ fontWeight: "500", color: "#33475b" }}>
            {row.typeName}
          </span>
        </div>
      ),
      width: "350px",
    },
    {
      name: "Status",
      selector: (row: viewdatas) => row.isActive,
      sortable: true,
      cell: (row: viewdatas) => {
        const isActive =
          typeof row.isActive === "boolean"
            ? row.isActive
            : row.isActive === "true";
        return (
          <span className={isActive ? "active-status" : "inactive-status"}>
            {isActive ? "ACTIVE" : "INACTIVE"}
          </span>
        );
      },
      width: "350px",
    },
    {
      name: "",
      cell: (row: viewdatas) => (
        <div className="action-cell">
          <button
            className="action-button edit-button"
            title="Edit Property Type"
            onClick={() => onEdit(row)}
          >
            <i className="bi bi-pencil-square"></i>
          </button>
          <button className="action-button more-button" title="Replace Icon">
            <i className="bi bi-three-dots"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "60px",
      className: "sticky-action-column",
    },
  ];

  return (
    <div className="card">
      <div className="card-header carHeaderWithBtn d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">Property Types List</h5>
        {showAddButton && (
          <button
            type="button"
            className="demo-btn btn btn-outline-primary btn-sm"
            onClick={onAddClick}
          >
            <i className="fas fa-plus me-1"></i>+ Add Property Type
          </button>
        )}
      </div>
      <div className="card-body p-0">
        <DataTable
          columns={columns}
          data={viewData}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
          highlightOnHover
          striped
          responsive
          noDataComponent={
            <div className="text-center py-4">
              <p className="text-muted mb-0">No property types found.</p>
            </div>
          }
          selectableRows
          selectableRowsComponentProps={{
            className: "custom-checkbox",
          }}
          onSelectedRowsChange={handleRowSelected}
          clearSelectedRows={toggleCleared}
          fixedHeader
          fixedHeaderScrollHeight="400px"
        />
      </div>
    </div>
  );
};

export default ViewPropertyTypeCard;
